import React from 'react';
import { Link } from 'react-router-dom';
import { sitemap } from '../pages/sitemap';

const Footer = () => {
  return (
    <footer className="bg-gray-100 py-12 px-6 border-t">
      <div className="max-w-7xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
        {sitemap.map((section, idx) => (
          <div key={idx}>
            <h3 className="text-sm font-bold text-gray-900 mb-3">{section.title}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              {section.links.map((link, index) => (
                link.external ? (
                  <li key={index}>
                    <a
                      href={link.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={index}>
                    <Link to={link.path} className="hover:underline">
                      {link.label}
                    </Link>
                  </li>
                )
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="text-xs text-center text-gray-500 mt-10 border-t pt-6">
        © {new Date().getFullYear()} Community Portal · All rights reserved ·{' '}
        <Link to="/privacy" className="underline hover:text-indigo-500">Privacy Policy</Link>
      </div>
    </footer>
  );
};

export default Footer;
